// extracted by mini-css-extract-plugin
export default {"footerText":"SibiFooter_footerText__v-BF9","sibiFooter":"SibiFooter_sibiFooter__NW6+Y","navItem":"SibiFooter_navItem__WVjmR"};